import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询用车申请单
export function queryUseCarApplicationForm(data) {
  return request({
    url: URL.booking.airExport.queryUseCarApplicationForm,
    method: 'post',
    data
  })
}

// 保存车单
export function saveCarForm(data) {
  return request({
    url: URL.booking.airExport.saveCarForm,
    method: 'post',
    data
  })
}

// 车单详情
export function carFormDetail(data) {
  return request({
    url: URL.booking.airExport.carFormDetail,
    method: 'post',
    data
  })
}

// 取消车单
export function cancelCarForm(data) {
  return request({
    url: URL.booking.airExport.cancelCarForm,
    method: 'post',
    data
  })
}

// 编辑车单状态
export function editCarFormStatus(data) {
  return request({
    url: URL.booking.airExport.editCarFormStatus,
    method: 'post',
    data
  })
}

// 查询状态变更记录
export function queryStatusRecords(data) {
  return request({
    url: URL.booking.airExport.queryStatusRecords,
    method: 'post',
    data
  })
}

// 查询车单
export function queryCarForm(data) {
  return request({
    url: URL.booking.airExport.queryCarForm,
    method: 'post',
    data
  })
}
